const FrenchDeck =
  [
    {
      "id": "0",
      "suit": "hearts",
      "value": 2
    },
    {
      "id": "1",
      "suit": "hearts",
      "value": 3
    },
    {
      "id": "2",
      "suit": "hearts",
      "value": 4
    },
    {
      "id": "3",
      "suit": "hearts",
      "value": 5
    },
    {
      "id": "4",
      "suit": "hearts",
      "value": 6
    },
    {
      "id": "5",
      "suit": "hearts",
      "value": 7
    },
    {
      "id": "6",
      "suit": "hearts",
      "value": 8
    },
    {
      "id": "7",
      "suit": "hearts",
      "value": 9
    },
    {
      "id": "8",
      "suit": "hearts",
      "value": 10
    },
    {
      "id": "9",
      "suit": "hearts",
      "value": "J"
    },
    {
      "id": "10",
      "suit": "hearts",
      "value": "Q"
    },
    {
      "id": "11",
      "suit": "hearts",
      "value": "K"
    },
    {
      "id": "12",
      "suit": "hearts",
      "value": "A"
    },
    {
      "id": "13",
      "suit": "diamonds",
      "value": 2
    },
    {
      "id": "14",
      "suit": "diamonds",
      "value": 3
    },
    {
      "id": "15",
      "suit": "diamonds",
      "value": 4
    },
    {
      "id": "16",
      "suit": "diamonds",
      "value": 5
    },
    {
      "id": "17",
      "suit": "diamonds",
      "value": 6
    },
    {
      "id": "18",
      "suit": "diamonds",
      "value": 7
    },
    {
      "id": "19",
      "suit": "diamonds",
      "value": 8
    },
    {
      "id": "20",
      "suit": "diamonds",
      "value": 9
    },
    {
      "id": "21",
      "suit": "diamonds",
      "value": 10
    },
    {
      "id": "22",
      "suit": "diamonds",
      "value": "J"
    },
    {
      "id": "23",
      "suit": "diamonds",
      "value": "Q"
    },
    {
      "id": "24",
      "suit": "diamonds",
      "value": "K"
    },
    {
      "id": "25",
      "suit": "diamonds",
      "value": "A"
    },
    {
      "id": "26",
      "suit": "clubs",
      "value": 2
    },
    {
      "id": "27",
      "suit": "clubs",
      "value": 3
    },
    {
      "id": "28",
      "suit": "clubs",
      "value": 4
    },
    {
      "id": "29",
      "suit": "clubs",
      "value": 5
    },
    {
      "id": "30",
      "suit": "clubs",
      "value": 6
    },
    {
      "id": "31",
      "suit": "clubs",
      "value": 7
    },
    {
      "id": "32",
      "suit": "clubs",
      "value": 8
    },
    {
      "id": "33",
      "suit": "clubs",
      "value": 9
    },
    {
      "id": "34",
      "suit": "clubs",
      "value": 10
    },
    {
      "id": "35",
      "suit": "clubs",
      "value": "J"
    },
    {
      "id": "36",
      "suit": "clubs",
      "value": "Q"
    },
    {
      "id": "37",
      "suit": "clubs",
      "value": "K"
    },
    {
      "id": "38",
      "suit": "clubs",
      "value": "A"
    },
    {
      "id": "39",
      "suit": "spades",
      "value": 2
    },
    {
      "id": "40",
      "suit": "spades",
      "value": 3
    },
    {
      "id": "41",
      "suit": "spades",
      "value": 4
    },
    {
      "id": "42",
      "suit": "spades",
      "value": 5
    },
    {
      "id": "43",
      "suit": "spades",
      "value": 6
    },
    {
      "id": "44",
      "suit": "spades",
      "value": 7
    },
    {
      "id": "45",
      "suit": "spades",
      "value": 8
    },
    {
      "id": "46",
      "suit": "spades",
      "value": 9
    },
    {
      "id": "47",
      "suit": "spades",
      "value": 10
    },
    {
      "id": "48",
      "suit": "spades",
      "value": "J"
    },
    {
      "id": "49",
      "suit": "spades",
      "value": "Q"
    },
    {
      "id": "50",
      "suit": "spades",
      "value": "K"
    },
    {
      "id": "51",
      "suit": "spades",
      "value": "A"
    }
  ]

export default FrenchDeck;